import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Position Reports")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "overlay-wrapper" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = {
  key: 0,
  class: "table align-middle fs-6 gy-3 table-row-bordered border"
}
const _hoisted_7 = { role: "row" }
const _hoisted_8 = {
  colspan: "13",
  id: "company_name",
  rowspan: "1",
  style: {"width":"1131px"}
}
const _hoisted_9 = { role: "row" }
const _hoisted_10 = {
  colspan: "3",
  id: "supplier_name",
  rowspan: "1",
  style: {"width":"188px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"73px"}
}, null, -1)
const _hoisted_12 = {
  colspan: "2",
  id: "commodity",
  rowspan: "1",
  style: {"width":"200px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, null, -1)
const _hoisted_14 = {
  colspan: "2",
  id: "start_date",
  rowspan: "1",
  style: {"width":"146px"}
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"43px"}
}, null, -1)
const _hoisted_16 = {
  colspan: "3",
  id: "duration",
  rowspan: "1",
  style: {"width":"270px"}
}
const _hoisted_17 = { role: "row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"25px"}
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}, " % Fixed ", -1)
const _hoisted_20 = {
  key: 0,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_21 = {
  key: 1,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_22 = {
  key: 2,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"73px"}
}
const _hoisted_23 = {
  key: 3,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"73px"}
}
const _hoisted_24 = {
  key: 4,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"51px"}
}
const _hoisted_25 = {
  key: 5,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"51px"}
}
const _hoisted_26 = {
  key: 6,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}
const _hoisted_27 = {
  key: 7,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " MTM ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Baseline ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Fixed Price Contract ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Budget ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Savings V Baseline ", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Savings V Fixed Contract ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, " Savings V Budget ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", {
  style: {"text-align":"right","width":"52px"},
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " %Savings ", -1)
const _hoisted_42 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"63px"}
}, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"43px"}
}, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"61px"}
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " Locked Savings ", -1)
const _hoisted_47 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_48 = {
  key: 1,
  class: "table align-middle fs-6 gy-3 table-row-bordered border"
}
const _hoisted_49 = { role: "row" }
const _hoisted_50 = {
  colspan: "10",
  id: "company_name",
  rowspan: "1",
  style: {"width":"1131px"}
}
const _hoisted_51 = { role: "row" }
const _hoisted_52 = {
  colspan: "2",
  id: "supplier_name",
  rowspan: "1",
  style: {"width":"188px"}
}
const _hoisted_53 = {
  colspan: "2",
  id: "commodity",
  rowspan: "1",
  style: {"width":"200px"}
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("th", {
  rowspan: "1",
  colspan: "2",
  style: {"width":"52px"}
}, null, -1)
const _hoisted_55 = {
  colspan: "2",
  id: "start_date",
  rowspan: "1",
  style: {"width":"146px"}
}
const _hoisted_56 = {
  colspan: "2",
  id: "duration",
  rowspan: "1",
  style: {"width":"270px"}
}
const _hoisted_57 = { role: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"25px"}
}, null, -1)
const _hoisted_59 = {
  key: 0,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_60 = {
  key: 1,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}, " Forecast Energy Cost ", -1)
const _hoisted_62 = {
  key: 2,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_63 = {
  key: 3,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_64 = {
  key: 4,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"73px"}
}
const _hoisted_65 = {
  key: 5,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"73px"}
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"51px"}
}, " Budget ", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"51px"}
}, " Original Budget ", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " Savings v Current Budget ", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " Savings v Original Budget ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " % Fixed ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, /*#__PURE__*/_toDisplayString("Total"), -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", {
  style: {"text-align":"right","width":"52px"},
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " %Savings ", -1)
const _hoisted_77 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"63px"}
}, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"43px"}
}, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " Locked Savings ", -1)
const _hoisted_81 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_82 = {
  key: 2,
  class: "table align-middle fs-6 gy-3 table-row-bordered border"
}
const _hoisted_83 = { role: "row" }
const _hoisted_84 = {
  colspan: "7",
  id: "company_name",
  rowspan: "1",
  style: {"width":"1131px"}
}
const _hoisted_85 = { role: "row" }
const _hoisted_86 = {
  colspan: "2",
  id: "supplier_name",
  rowspan: "1",
  style: {"width":"188px"}
}
const _hoisted_87 = {
  colspan: "2",
  id: "commodity",
  rowspan: "1",
  style: {"width":"200px"}
}
const _hoisted_88 = {
  colspan: "1",
  id: "start_date",
  rowspan: "1",
  style: {"width":"146px"}
}
const _hoisted_89 = {
  colspan: "2",
  id: "duration",
  rowspan: "1",
  style: {"width":"270px"}
}
const _hoisted_90 = { role: "row" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"25px"}
}, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " % Fixed ", -1)
const _hoisted_93 = {
  key: 0,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_94 = {
  key: 1,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_95 = {
  key: 2,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_96 = {
  key: 3,
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"57px"}
}, " Forecast Energy Cost ", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"51px"}
}, " Budget ", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("th", {
  class: "sorting_disabled",
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, " Savings v Current Budget ", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1"
}, null, -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"52px"}
}, null, -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  style: {"width":"49px"}
}, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("td", {
  style: {"text-align":"right","width":"52px"},
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " %Savings ", -1)
const _hoisted_104 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", {
  rowspan: "1",
  colspan: "1",
  class: "fw-bolder"
}, " Locked Savings ", -1)
const _hoisted_106 = {
  colspan: "1",
  rowspan: "1",
  class: "fw-bolder"
}
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = { key: 2 }
const _hoisted_110 = { key: 3 }
const _hoisted_111 = { key: 4 }
const _hoisted_112 = { key: 5 }
const _hoisted_113 = { key: 6 }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark-o-25" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner spinner-primary" })
], -1)
const _hoisted_115 = {
  key: 0,
  style: {},
  id: "loadingDiv"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_117 = [
  _hoisted_116
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isTwelveCol)
              ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_7, [
                      _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.MainValues.customer_Name), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_9, [
                      _createElementVNode("th", _hoisted_10, " Supplier:" + _toDisplayString(_ctx.MainValues.supplier_Name), 1),
                      _hoisted_11,
                      _createElementVNode("th", _hoisted_12, " Commodity:" + _toDisplayString(_ctx.MainValues.commodity), 1),
                      _hoisted_13,
                      _createElementVNode("th", _hoisted_14, " Start Date: " + _toDisplayString(_ctx.MainValues.startDate), 1),
                      _hoisted_15,
                      _createElementVNode("th", _hoisted_16, " Duration: " + _toDisplayString(_ctx.MainValues.duration), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_20, " Baseline p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_21, " Baseline p/MWh "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_22, " Fixed Price Contract p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_23, " Fixed Price Contract p/MWh "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_24, " Budget p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_25, " Budget p/MWh "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_26, " MTM p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_27, " MTM p/MWh "))
                        : _createCommentVNode("", true),
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OriginalRow1, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        role: "row",
                        key: index
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index == 0 ? "Current" : "Original"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.fixed_per) + " %", 1),
                        _createElementVNode("td", null, _toDisplayString(item.baseline), 1),
                        _createElementVNode("td", null, _toDisplayString(item.f_price_contract), 1),
                        _createElementVNode("td", null, _toDisplayString(item.budget), 1),
                        _createElementVNode("td", null, _toDisplayString(item.mtm), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.mtm_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.baseline_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.fpc_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.budget_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.savings_baseline)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.savings_fpc)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.savings_budget)), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.MainValues.savings_per), 1),
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46,
                      _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.$filters.StringFormat(_ctx.MainValues.locked_savings)), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isNineCol)
              ? (_openBlock(), _createElementBlock("table", _hoisted_48, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_49, [
                      _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.MainValues.customer_Name), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_51, [
                      _createElementVNode("th", _hoisted_52, " Supplier:" + _toDisplayString(_ctx.MainValues.supplier_Name), 1),
                      _createElementVNode("th", _hoisted_53, " Commodity:" + _toDisplayString(_ctx.MainValues.commodity), 1),
                      _hoisted_54,
                      _createElementVNode("th", _hoisted_55, " Start Date: " + _toDisplayString(_ctx.MainValues.startDate), 1),
                      _createElementVNode("th", _hoisted_56, " Duration: " + _toDisplayString(_ctx.MainValues.duration), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_57, [
                      _hoisted_58,
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_59, " Energy Rate p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_60, " Energy Rate p/KWh "))
                        : _createCommentVNode("", true),
                      _hoisted_61,
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_62, " Current Budget p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_63, " Current Budget p/KWh "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_64, " Original Budget p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_65, " Original Budget p/KWh "))
                        : _createCommentVNode("", true),
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _hoisted_70
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_71,
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat((_ctx.OriginalRow1[1].mtm / 10).toFixed(3))), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(_ctx.OriginalRow1[1].forecast_energy_cost)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(
                      (_ctx.OriginalRow1[1].budget / 10).toFixed(3)
                    )), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(
                      (_ctx.OriginalRow1[0].budget / 10).toFixed(3)
                    )), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(_ctx.OriginalRow1[1].budget_cost)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(_ctx.OriginalRow1[0].budget_cost)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(_ctx.OriginalRow1[1].savings_budget)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(_ctx.OriginalRow1[0].savings_budget)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.OriginalRow1[0].fixed_per) + " %", 1)
                    ])
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_72,
                      _hoisted_73,
                      _hoisted_74,
                      _hoisted_75,
                      _hoisted_76,
                      _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.MainValues.savings_per), 1),
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.$filters.StringFormat(_ctx.MainValues.locked_savings)), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isSixCol)
              ? (_openBlock(), _createElementBlock("table", _hoisted_82, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_83, [
                      _createElementVNode("th", _hoisted_84, _toDisplayString(_ctx.MainValues.customer_Name), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_85, [
                      _createElementVNode("th", _hoisted_86, " Supplier:" + _toDisplayString(_ctx.MainValues.supplier_Name), 1),
                      _createElementVNode("th", _hoisted_87, " Commodity:" + _toDisplayString(_ctx.MainValues.commodity), 1),
                      _createElementVNode("th", _hoisted_88, " Start Date: " + _toDisplayString(_ctx.MainValues.startDate), 1),
                      _createElementVNode("th", _hoisted_89, " Duration: " + _toDisplayString(_ctx.MainValues.duration), 1)
                    ]),
                    _createElementVNode("tr", _hoisted_90, [
                      _hoisted_91,
                      _hoisted_92,
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_93, " Budget p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_94, " Budget p/KWh "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Gas')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_95, " Energy Rate p/th "))
                        : _createCommentVNode("", true),
                      (_ctx.MainValues.commodity === 'Electricity')
                        ? (_openBlock(), _createElementBlock("th", _hoisted_96, " Energy Rate p/KWh "))
                        : _createCommentVNode("", true),
                      _hoisted_97,
                      _hoisted_98,
                      _hoisted_99
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OriginalRow1, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        role: "row",
                        key: index
                      }, [
                        _createElementVNode("td", null, _toDisplayString(index == 0 ? "Current" : "Original"), 1),
                        _createElementVNode("td", null, _toDisplayString(item.fixed_per) + " %", 1),
                        _createElementVNode("td", null, _toDisplayString(Math.round(item.budget * 100) / 1000), 1),
                        _createElementVNode("td", null, _toDisplayString(Math.round(item.mtm * 100) / 1000), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.mtm_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.budget_cost)), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$filters.StringFormat(item.savings_budget)), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _hoisted_103,
                      _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.MainValues.savings_per), 1),
                      _hoisted_105,
                      _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.$filters.StringFormat(_ctx.MainValues.locked_savings)), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.addition)
            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTable,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.iselecactive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTableelecactive,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.iseleccurrent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTableeleccurrent,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.iselechistoric)
            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTableelechistoric,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isgasactive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTablegasactive,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isgascurrent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTablegascurrent,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isgashistoric)
            ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                _createVNode(_component_TableTab, {
                  "table-data": _ctx.PositionDataTablegashistoric,
                  "table-header": _ctx.columnHeaders,
                  "enable-items-per-page-dropdown": true,
                  selectedType: _ctx.colnames,
                  pagetitle: _ctx.pageheader
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.colnames, (slot) => {
                    return {
                      name: `cell-${slot}`,
                      fn: _withCtx(({ row: customer }) => [
                        _createTextVNode(_toDisplayString(customer[slot]), 1)
                      ])
                    }
                  })
                ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_114
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_115, _hoisted_117))
      : _createCommentVNode("", true)
  ], 64))
}